// extracted by mini-css-extract-plugin
export var errorIcon = "_k1-1";
export var nameLogo = "_k1-0";